export default __webpack_public_path__ + "static/media/album2.9d3afad7.png";